import { escapeHtml } from "./blocks/factories";

export const SOCIAL_PLATFORMS = [
  { key: "instagram", label: "Instagram", color: "#E4405F", iconMarkup: `<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" style="display:block;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round"><rect x="3" y="3" width="18" height="18" rx="5" ry="5"></rect><circle cx="12" cy="12" r="4"></circle><circle cx="17.5" cy="6.5" r="1"></circle></svg>` },
  { key: "tiktok", label: "TikTok", color: "#000000", iconMarkup: `<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" style="display:block;fill:currentColor"><path d="M14 3v10.3a4.7 4.7 0 1 1-3.3-4.5V12a2 2 0 1 0 1.3 1.9V3h2z"></path><path d="M14 5c.8 1.8 2.2 2.9 4 3.2V10c-1.7-.2-3-1-4-2.3V5z"></path></svg>` },
  { key: "facebook", label: "Facebook", color: "#1877F2", iconMarkup: `<span aria-hidden="true" style="font-size:20px;font-weight:700;line-height:1;font-family:Arial,Helvetica,sans-serif">f</span>` },
  { key: "twitter", label: "X", color: "#000000", iconMarkup: `<span aria-hidden="true" style="font-size:16px;font-weight:800;line-height:1;font-family:Arial,Helvetica,sans-serif">X</span>` },
  { key: "goodreads", label: "Goodreads", color: "#553B08", iconMarkup: `<span aria-hidden="true" style="font-size:20px;font-weight:700;line-height:1;font-family:Georgia,'Times New Roman',serif">g</span>` },
  { key: "amazon", label: "Amazon Author", color: "#FF9900", iconMarkup: `<span aria-hidden="true" style="font-size:20px;font-weight:700;line-height:1;font-family:Georgia,'Times New Roman',serif">a</span>` },
  { key: "bookbub", label: "BookBub", color: "#F44336", iconMarkup: `<span aria-hidden="true" style="font-size:20px;font-weight:700;line-height:1;font-family:Georgia,'Times New Roman',serif">b</span>` },
];

export const SOCIAL_PLACEMENTS = {
  BODY_BLOCK: "body-block",
  FOOTER: "footer",
};

export function getSocialIconMarkup(platform) {
  return platform.iconMarkup || `<span aria-hidden="true">${escapeHtml(platform.label[0] || "?")}</span>`;
}

export function normalizeSocialLinks(links = {}) {
  const cleaned = {};
  for (const [key, value] of Object.entries(links || {})) {
    const trimmed = (value || "").trim();
    if (trimmed) cleaned[key] = trimmed;
  }
  return cleaned;
}

export function parseLegacySocialLinks(container) {
  if (!container || !container.querySelectorAll) return { links: null, parseFailed: true };

  const anchors = Array.from(container.querySelectorAll("a[data-social], a[title], a[href]"));
  if (!anchors.length) return { links: null, parseFailed: true };

  const parsed = {};
  anchors.forEach((anchor) => {
    const href = (anchor.getAttribute("href") || "").trim();
    if (!href) return;

    const explicitKey = (anchor.getAttribute("data-social") || "").trim().toLowerCase();
    if (explicitKey) {
      parsed[explicitKey] = href;
      return;
    }

    const title = (anchor.getAttribute("title") || "").toLowerCase();
    const match = SOCIAL_PLATFORMS.find((p) => title.includes(p.label.toLowerCase()) || href.toLowerCase().includes(p.key));
    if (match) parsed[match.key] = href;
  });

  const cleaned = normalizeSocialLinks(parsed);
  return Object.keys(cleaned).length ? { links: cleaned, parseFailed: false } : { links: null, parseFailed: true };
}
